import { axios, getConfigs } from './common';

export default class MessageTemplateService {
  async getList(params) {
    return new Promise(async (resolve, reject) => {
      let url = `/templates`;

      const options = {};
      const configs = getConfigs('get', 'application/json', url, options);

      configs.params = params;

      axios(configs, resolve, reject);
    });
  }
}